import { db, storage } from '../firebase';
import { collection, addDoc, query, where, orderBy, onSnapshot, serverTimestamp, getDocs, deleteDoc, doc, limit } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

/**
 * Uploads a story (image/video).
 */
export const uploadStory = async (user, file) => {
    if (!user || !file) throw new Error("Invalid user or file");

    const storageRef = ref(storage, `users/${user.uid}/stories/${Date.now()}_${file.name}`);
    await uploadBytes(storageRef, file);
    const mediaUrl = await getDownloadURL(storageRef);

    const storyData = {
        uid: user.uid,
        userName: user.name || user.displayName || 'Anonymous',
        userPhoto: user.photoURL || user.images?.[0] || null,
        mediaUrl,
        mediaType: file.type.startsWith('video') ? 'video' : 'image',
        createdAt: serverTimestamp(),
        // We handle expiration by filtering in the query, but storing it helps for TTL if enabled
        expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000)
    };

    const docRef = await addDoc(collection(db, 'stories'), storyData);
    return { id: docRef.id, ...storyData };
};

/**
 * Listens to active stories (less than 24 hours old).
 */
export const listenToStories = (callback) => {
    const storiesRef = collection(db, 'stories');
    const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);

    const q = query(
        storiesRef,
        where('createdAt', '>=', twentyFourHoursAgo),
        orderBy('createdAt', 'desc')
    );

    return onSnapshot(q, (snapshot) => {
        const stories = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        callback(stories);
    });
};
